import { eEstadoTipoVisita } from "../common/enumModel";
import { IFilterTipoVisitaModel } from "../interfaces/tipo-visita/IFilterTipoVisitaModel";

export class FilterTipoVisitaModel implements IFilterTipoVisitaModel {    
    idTipoVisitas: number[];
    tipoVisita: string;
    idEstado: eEstadoTipoVisita;
    page: number;
    pageSize: number;

    constructor(){
        this.idTipoVisitas = new Array<number>();
        this.tipoVisita = '';
        this.idEstado = eEstadoTipoVisita.ACTIVO;
        this.page = 1;
        this.pageSize = 30;
    }
}